/**
 * PublicControls
 *
 * The public shared-map control pair — language switcher + theme toggle. Both
 * are safe unauthenticated (preferences sync to the backend only for logged-in
 * users). Kept as one component so the exact same pair can sit in the floating
 * pill (`PublicFloatingControls`) and be folded into the detail panel toolbar
 * (`SharedMapPage` → `PublicArtifactDetail` `toolbarActions`) without the two
 * copies drifting.
 *
 * @module components/share/public/PublicControls
 */
import { memo } from 'react';

import { LanguageSelector } from '@/components/ui/LanguageSelector';
import { ThemeToggleButton } from '@/components/ui/ThemeToggleButton';

export const PublicControls = memo(function PublicControls() {
  return (
    <>
      <LanguageSelector size="md" />
      <ThemeToggleButton />
    </>
  );
});
